import { Component, Input, OnChanges, signal, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CIPXQuoteRequestIntakeForm, CIPXQuoteRequestIntakeFormStateBond, CIPXQuoteRequestIntakeFormStateBondDetailedQuestion } from '../intake-form.types';
import { SharedModule } from '@sbd-account-portal/app/shared/shared.module';
import { SharedComponentsModule } from '@sbd-doug-frontend/shared/lib/shared-components/shared-components.module';
import { getQuestionsForSection, isQuestionVisible } from '../intake-form.helpers';
import { CIPXQuoteRequestIntakeFormQuestionControlComponent } from '../question-control/question-control.component';

@Component({
  standalone: true,
  imports: [
    SharedModule,
    SharedComponentsModule,
    CIPXQuoteRequestIntakeFormQuestionControlComponent
  ],
  selector: 'cipx-quote-request-intake-form-question-set',
  templateUrl: 'question-set.component.html'
})

export class CIPXQuoteRequestIntakeFormQuestionSetComponent implements OnChanges {
  @Input() quoteRequestForm!: FormGroup<CIPXQuoteRequestIntakeForm>;
  @Input() stateBond!: CIPXQuoteRequestIntakeFormStateBond | null;
  @Input() sectionName: string = 'unknown';

  questions = signal<CIPXQuoteRequestIntakeFormStateBondDetailedQuestion[]>([]);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['stateBond'] && this.stateBond) {
      this.questions.set(getQuestionsForSection(this.sectionName, this.stateBond));
    }
  }

  get additionalQuestionsGroup(): FormGroup {
    return this.quoteRequestForm.controls.additional_questions as FormGroup;
  }

  isVisible(question: CIPXQuoteRequestIntakeFormStateBondDetailedQuestion): boolean {
    return isQuestionVisible(question, this.additionalQuestionsGroup);
  }
}
